import React from 'react';
import styled from 'styled-components';

import { Typography, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { colors } from '../../../styles/colors/';

const StyledContainer = styled.div`
  display: flex;
  height: 40px;
  width: 100%;
  padding: 8px 16px;
  margin-bottom: 16px;
  background: ${colors.neutral[2]};
  border-radius: 2px;
  border: 1px dashed ${colors.neutral[5]};
`;

const { Paragraph } = Typography;

export const PlaceholderDroppableArea = ({ label }) => (
  <StyledContainer>
    <Space align="baseline">
      <PlusOutlined color={colors.gray[7]} />
      <Paragraph>{label}</Paragraph>
    </Space>
  </StyledContainer>
);

export default PlaceholderDroppableArea;
